





































import { Component, Vue } from "vue-property-decorator";
import { Carousel, Tooltip } from "ant-design-vue";

@Component({
  name: "Tools",
  components: {
    ACarousel: Carousel,
    ATooltip: Tooltip
  }
})
export default class Tools extends Vue {
  private pageNum = 1;
  private total = 0;
  private pageSize = 200;
  private dataSource: any[] = [];
  // 一页显示几个项目
  private carouselStep = 8;

  private created() {
    this.getList();
  }

  private async getList() {
    const res = await this.$api.DownloadList({
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      status: "0"
    });
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
    return res;
  }

  private urlWarning() {
    this.$modal.warning({ content: "下载地址不存在！" });
  }

  private get list() {
    const step = this.carouselStep;
    const _return: any[] = Array.from({ length: Math.ceil(this.dataSource.length / step) }, () => []);
    for (let i = 0; i < _return.length; i++) {
      for (let j = i * step; j < i * step + step; j++) {
        if (this.dataSource[j]) {
          _return[i].push(this.dataSource[j]);
        } else {
          break;
        }
      }
    }
    return _return;
  }
}
